import React from 'react';
import { Briefcase, Calendar, Shield, Bell } from 'lucide-react';
import CTASection from '../../components/CTASection';

const CopyrightPortfolioPage = () => {
  return (
    <div>
      <div className="bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-6">Copyright <span className="text-[#FF6B35]">Portfolio Management</span></h1>
          <p className="text-xl text-gray-300 max-w-3xl">Comprehensive management and strategic oversight of your entire copyright portfolio.</p>
        </div>
      </div>
      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto space-y-6 text-lg text-gray-700">
            <p>For creators and businesses with extensive copyright holdings, professional portfolio management ensures nothing falls through the cracks. We track registrations, monitor for infringement, manage licensing agreements, and provide strategic guidance for portfolio expansion.</p>
            <p>Our centralized dashboard gives you complete visibility into your copyright assets, renewal dates, licensing revenue, and enforcement actions. We handle administrative tasks so you can focus on creating.</p>
          </div>
        </div>
      </div>
      <div className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="bg-white rounded-xl p-6 text-center">
              <Briefcase className="w-12 h-12 text-[#FF6B35] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Centralized Management</h3>
              <p className="text-gray-700 text-sm">All copyrights in one organized system</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <Calendar className="w-12 h-12 text-[#FF6B35] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Renewal Tracking</h3>
              <p className="text-gray-700 text-sm">Never miss important deadlines</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <Bell className="w-12 h-12 text-[#FF6B35] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Infringement Monitoring</h3>
              <p className="text-gray-700 text-sm">Continuous surveillance for unauthorized use</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <Shield className="w-12 h-12 text-[#FF6B35] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Strategic Planning</h3>
              <p className="text-gray-700 text-sm">Maximize value of your copyright assets</p>
            </div>
          </div>
        </div>
      </div>
      <CTASection />
    </div>
  );
};

export default CopyrightPortfolioPage;